<template>
  <section v-if="props.list?.length" class="other-cities mb-5 md:mb-6">
    <!-- 使用 `once` 來防止切換 region 時導致的 UI 跳動 -->
    <carousel v-once :title="$t('home.other_cities.title')" navigator :data="props.list" swiper-container-class="mt-2 md:mt-4">
      <template #default="{ item }">
        <locale-link
          v-gtm:click="{ event: GtmEvent.REGION_CHANGED, payload: { toRegion: item } }"
          :to="`/regions/${item.id}`"
          class="relative block overflow-hidden rounded"
          @click="handleCityClick(item)"
        >
          <etg-img class="w-234px h-292px object-cover" :src="`fn:${item.cover_image}`" :alt="item.name" />
          <div class="mask bg-opacity-40 absolute top-0 left-0 flex w-full h-full bg-black-80 pt-5 px-5">
            <p class="text-center text-xl text-white line-clamp-2 w-full">{{ item.name }}</p>
          </div>
        </locale-link>
      </template>
      <template #skeleton>
        <div class="skeleton-wrapper flex gap-2 overflow-hidden md:gap-5">
          <div v-for="i in 4" :key="i" class="skeleton-card">
            <n-skeleton class="w-234px h-292px rounded" />
          </div>
        </div>
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import { NSkeleton } from 'naive-ui'
import Carousel from '@/components/common/carousel.vue'

import { useAuthStore } from '@/store/auth'

import type { RegionOtherRegionData } from '@/types/api'
import { GtmEvent } from '@/types/gtm'

interface Props {
  list: RegionOtherRegionData[]
}

const authStore = useAuthStore()

const props = defineProps<Props>()

const handleCityClick = async (item: RegionOtherRegionData) => {
  if (authStore.isLogin && item.id) await authStore.updateMemberRegion(item.id)
}
</script>
